import { render, staticRenderFns } from "./PluginSetting.vue?vue&type=template&id=ddfc328c&scoped=true"
import script from "./PluginSetting.vue?vue&type=script&lang=js"
export * from "./PluginSetting.vue?vue&type=script&lang=js"
import style0 from "./PluginSetting.vue?vue&type=style&index=0&id=ddfc328c&prod&lang=stylus&scoped=true"
import style1 from "./PluginSetting.vue?vue&type=style&index=1&id=ddfc328c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfc328c",
  null
  
)

export default component.exports